/**
 * Cache Policy Configuration
 * 
 * Business rules for caching behavior.
 * These are business decisions (how long to cache, when to invalidate),
 * so they belong in mapping-unit.
 */

export const CachePolicy = {
  /**
   * How long to cache recommendation results (5 minutes)
   * Business rule: Recommendations are expensive, cache for reasonable time
   */
  RECOMMENDATION_TTL_MS: 5 * 60 * 1000,

  /**
   * Maximum cache size (number of entries)
   * Business rule: Prevent memory issues by limiting cache
   */
  MAX_CACHE_SIZE: 100,

  /**
   * Cache version (for invalidation when API changes)
   */
  CACHE_VERSION: 'v1',

  /**
   * How long to cache module lists (15 minutes)
   * Business rule: Module lists change infrequently
   */
  MODULE_LIST_TTL_MS: 15 * 60 * 1000,

  /**
   * How long to cache deployment status (30 seconds)
   * Business rule: Deployment status changes frequently, short cache
   */
  DEPLOYMENT_STATUS_TTL_MS: 30 * 1000,
} as const;
